@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.badge {
  display: inline-flex;
  align-items: center;

  padding: 0.25rem 0.75rem;
  border-radius: 1rem;

  font-size: 0.75rem;
  font-weight: 500;

  transition:
    color 0.15s ease,
    background-color 0.15s ease,
    border-color 0.15s ease;
}

/* Variants */
.default {
  background-color: rgba(map.get(core.$colors, secondaryBlue), 0.1);
  color: map.get(core.$colors, secondaryBlue);
}

.blue {
  background-color: rgba(map.get(core.$colors, accent), 0.1);
  color: map.get(core.$colors, accent);
}

.green {
  background-color: rgba(map.get(core.$colors, success), 0.1);
  color: map.get(core.$colors, success);
}

.outline {
  background-color: #ffffff;
  color: map.get(core.$colors, darkGrey);
  border: 1px solid map.get(core.$colors, darkGrey);
}
